import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { c } from '@debbie/cortex/dist/index.js';
import { Button, Input, Header } from '../../index.js';
const PasswordCreator = (props) => {
    const lang = useSelector((s) => s.lang);
    const [password, setPassword] = useState('');
    const valid = password.length >= 8;
    return (React.createElement("div", null,
        React.createElement("form", { onSubmit: async (e) => {
                e.preventDefault();
                e.stopPropagation();
                const response = await c.auth.createPassword(props.token, password);
                if (response != null) {
                    const queryParams = new URLSearchParams(window.location.search);
                    queryParams.delete('nu_token');
                    window.location.search = queryParams.toString();
                }
            } },
            React.createElement(Header, null, lang.onboarding.welcome),
            React.createElement("p", null, lang.onboarding.passwordCreatorExplainer),
            React.createElement(Input, { type: "password", placeholder: lang.login.password, onChange: (e) => {
                    setPassword(e.target.value);
                }, value: password }),
            React.createElement(Button, { block: true, style: { marginBottom: '10px' }, disabled: !valid }, lang.misc.submit))));
};
export default PasswordCreator;
//# sourceMappingURL=PasswordCreator.js.map